import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { LayoutTemplate, Plus, Percent } from "lucide-react";
import { NewLandingDialog } from "@/components/landing/NewLandingDialog";
import { NewCampaignDialog } from "@/components/landing/CampaignParts";
import { LandingEditor } from "@/components/landing/LandingEditor";
import { StoreInfoButton } from "@/components/landing/StoreInfo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/landing`;
const DOT = { draft: "bg-zinc-500", hidden: "bg-amber-400", published: "bg-emerald-400" };

export default function LandingPages() {
  const [items, setItems] = useState([]);
  const [cur, setCur] = useState(null);
  const [creating, setCreating] = useState(false);
  const [campaign, setCampaign] = useState(false);
  const load = () => axios.get(API).then((r) => setItems(r.data.items || [])).catch((e) => toast.error(e.message));
  useEffect(() => { load(); }, []);
  const open = (id) => axios.get(`${API}/${id}`).then((r) => setCur(r.data));

  return (
    <div className="space-y-6 p-6" data-testid="landing-page">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="flex items-center gap-2 text-2xl font-semibold text-zinc-100"><LayoutTemplate className="h-6 w-6 text-amber-400" /> Landing pages</h1>
          <p className="mt-1 text-sm text-zinc-400">AI-ul scrie pagina din produsul Shopify, tu o corectezi, apoi o trimiți pe bragus.ro. Butonul „Comandă acum” duce direct la plată, iar comenzile se atribuie paginii.</p>
        </div>
        <div className="flex gap-2">
          <StoreInfoButton />
          <button data-testid="new-campaign-btn" onClick={() => setCampaign(true)} className="flex items-center gap-1.5 rounded-full border border-amber-400/60 px-4 py-2 text-sm font-semibold text-amber-200 hover:bg-amber-400 hover:text-zinc-950"><Percent className="h-4 w-4" /> Campanie reduceri</button>
          <button data-testid="new-landing-btn" onClick={() => setCreating(true)} className="flex items-center gap-1.5 rounded-full bg-amber-400 px-4 py-2 text-sm font-semibold text-zinc-950 hover:scale-[1.03]"><Plus className="h-4 w-4" /> Landing page nou</button>
        </div>
      </div>
      <div className="flex gap-3 overflow-x-auto pb-1" data-testid="landing-list">
        {items.length === 0 && <p className="text-sm text-zinc-500" data-testid="landing-empty">Niciun landing page încă.</p>}
        {items.map((lp) => (
          <button key={lp.id} data-testid={`landing-item-${lp.id}`} onClick={() => open(lp.id)} className={`min-w-[240px] rounded-xl border p-3 text-left transition-colors ${cur?.id === lp.id ? "border-amber-400 bg-amber-400/5" : "border-zinc-800 bg-zinc-900/50 hover:border-zinc-600"}`}>
            <div className="flex items-center gap-2"><span className={`h-2 w-2 rounded-full ${DOT[lp.status]}`} /><span className="truncate text-sm font-medium text-zinc-100">{lp.title}</span></div>
            <p className="mt-1 truncate text-[11px] text-zinc-500">{lp.kind === "campaign" ? `Campanie −${lp.percent}% · până ${new Date(lp.ends_at).toLocaleDateString("ro-RO")}` : `${lp.sku}${lp.angle ? ` · ${lp.angle}` : ""}`}</p>
            <p className="mt-2 text-xs text-zinc-300" data-testid={`landing-stats-${lp.id}`}><b>{lp.stats.orders}</b> comenzi · <b>{lp.stats.revenue.toLocaleString("ro-RO")}</b> lei</p>
          </button>
        ))}
      </div>
      {cur && <LandingEditor key={cur.id} lp={cur} onChanged={load} onDeleted={() => { setCur(null); load(); }} />}
      {campaign && <NewCampaignDialog onClose={() => setCampaign(false)} onCreated={(lp) => { setCur(lp); load(); }} />}
      {creating && <NewLandingDialog onClose={() => setCreating(false)} onCreated={(lp) => { setCur(lp); load(); }} />}
    </div>
  );
}
